import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Body, SubmitButton, Field, Icon, FormCadastro, GroupField, Input, InputNumber, PageHeader, Select, View } from '@components';
import { getConexoesSelect } from '@sdk/Conectores/Conexoes';
import { getHeadersSelect } from '@sdk/Conectores/Headers';
import { getFonteDado, putFonteDado, postFonteDado, reset } from '@ducks/conectoresFontesDados';
import App from '@app';
import styled from 'styled-components';
import { getTemplatesGrupos } from '@sdk/Conectores/Templates/Templates';
import { getTemplate, reset as resetTemplate } from '@ducks/conectoresTemplates';

const ViewURL = styled(View)`
  flex: 6;
`;

const FieldURL = styled(Field)`
  margin-bottom: 0;
  padding-right: 15px;
`;

const ViewTipURL = styled(View)`
  opacity: 0.6;
  font-size: 12px;
  flex-direction: row;
  align-items: center;
`;

const ViewCopiar = styled(View)`
  margin-top: -20px;
  margin-bottom: 20px;
  font-size: 12px;
  color: #1890ff !important;
  cursor: pointer;
`;

const tipsURL = ['https://teammove.app/api/v1/agrupador', 'https://teammove.app/api/v1/indicador/INDICADOR/v1'];

const apiMethods = [
  { key: 'GET', value: 'GET', title: 'GET' },
  { key: 'POST', value: 'POST', title: 'POST' },
  { key: 'PUT', value: 'PUT', title: 'PUT' },
  { key: 'DELETE', value: 'DELETE', title: 'DELETE' },
];

export default function Cadastro() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [form] = FormCadastro.useForm();
  const { id, idConfiguracao } = useParams();
  const edicao = id !== '-1';
  const [templateSelecionado, setTemplateSelecionado] = useState(null);

  const fonteDado = useSelector(({ conectoresFontesDados }) => conectoresFontesDados.get('fonteDado'));
  const successFonteDado = useSelector(({ conectoresFontesDados }) => conectoresFontesDados.get('successFonteDado'));

  const successPostFonteDado = useSelector(({ conectoresFontesDados }) => conectoresFontesDados.get('successPostFonteDado'));
  const successPutFonteDado = useSelector(({ conectoresFontesDados }) => conectoresFontesDados.get('successPutFonteDado'));

  const template = useSelector(({ conectoresTemplates }) => conectoresTemplates.get('template'));
  const successTemplate = useSelector(({ conectoresTemplates }) => conectoresTemplates.get('successTemplate'));

  const handleReset = () => {
    return dispatch(reset());
  };

  useEffect(() => {
    if (successPostFonteDado || successPutFonteDado) {
      handleReset();
      history.goBack();
    }
  }, [successPostFonteDado, successPutFonteDado]);

  useEffect(() => {
    if (successTemplate) {
      form.setFieldsValue({ nm: template.ds, sql: template.sql, url: template.url });
      dispatch(resetTemplate());
    }
  }, [successTemplate]);

  useEffect(() => {
    form.setFieldsValue({ metodo: 'PUT' });
    if (edicao) {
      dispatch(getFonteDado(idConfiguracao, id));
    }
  }, []);

  useEffect(() => {
    if (fonteDado && edicao) {
      form.setFieldsValue(fonteDado);

      if (fonteDado.idTemplate) setTemplateSelecionado(fonteDado.idTemplate);
    }
  }, [successFonteDado]);

  const getApiMethod = async () => {
    return apiMethods;
  };

  const handleSubmit = (data) => {
    data.idConfiguracao = idConfiguracao;
    data.idConexao = parseInt(data.idConexao.split('-')[0]);

    if (!data.idTemplate) data.idTemplate = null;

    if (edicao) {
      data.id = id;
      dispatch(putFonteDado(data));
    } else {
      dispatch(postFonteDado(data));
    }
  };

  const handleOnChangeTemplate = (value) => {
    setTemplateSelecionado(value);
  };

  const handleCopiarDados = () => {
    if (templateSelecionado) {
      dispatch(getTemplate(templateSelecionado));
    }
  };

  const handleCopyToClipboard = (str) => {
    const el = document.createElement('textarea');
    el.value = str;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  };

  return (
    <App>
      <Body>
        <PageHeader title='Fonte de Dado' onBack={() => history.goBack()}>
          <FormCadastro form={form} hideRequiredMark onFinish={handleSubmit}>
            <GroupField>
              <Field label='Template' name='idTemplate'>
                <Select
                  form={form}
                  name='idTemplate'
                  action={() => getTemplatesGrupos()}
                  placeholder='Selecione um template'
                  onChange={handleOnChangeTemplate}
                />
              </Field>
            </GroupField>
            {templateSelecionado && <ViewCopiar onClick={handleCopiarDados}>Copiar dados</ViewCopiar>}
            <GroupField>
              <Field label='Descrição' name='nm' rules={[{ required: true, message: 'Informe a descrição' }]}>
                <Input autoFocus />
              </Field>
              <Field label='Conexão' name='idConexao' rules={[{ required: true, message: 'Informe a conexão' }]}>
                <Select
                  form={form}
                  allowClear={false}
                  name='idConexao'
                  action={() => getConexoesSelect(idConfiguracao)}
                  placeholder='Selecione uma conexão'
                />
              </Field>
              <Field label='Header' name='idHeader' rules={[{ required: true, message: 'Informe o header' }]}>
                <Select
                  form={form}
                  allowClear={false}
                  name='idHeader'
                  action={() => getHeadersSelect(idConfiguracao)}
                  placeholder='Selecione um header'
                />
              </Field>
            </GroupField>
            <GroupField>
              <ViewURL>
                <FieldURL label='URL' name='url' rules={[{ required: true, message: 'Informe a URL' }]}>
                  <Input />
                </FieldURL>
                <ViewTipURL>
                  Agrupador: {tipsURL[0]} &nbsp; <Icon.CopyOutlined onClick={() => handleCopyToClipboard(tipsURL[0])} />
                </ViewTipURL>
                <ViewTipURL>
                  Indicador: {tipsURL[1]} &nbsp; <Icon.CopyOutlined onClick={() => handleCopyToClipboard(tipsURL[1])} />
                </ViewTipURL>
              </ViewURL>
              <Field label='Método' name='metodo' rules={[{ required: true, message: 'Informe o método' }]}>
                <Select form={form} allowClear={false} name='metodo' action={() => getApiMethod()} placeholder='Selecione um método' />
              </Field>
              <Field label='Ordem' name='ordem' rules={[{ required: true, message: 'Informe a ordem' }]}>
                <InputNumber />
              </Field>
            </GroupField>
            <GroupField>
              <Field label='SQL' name='sql' rules={[{ required: true, message: 'Informe o SQL' }]}>
                <Input.TextArea rows={15} />
              </Field>
            </GroupField>
            <SubmitButton type='success' htmlType='submit' block>
              Salvar
            </SubmitButton>
          </FormCadastro>
        </PageHeader>
      </Body>
    </App>
  );
}
